module.exports = __webpack_public_path__ + "img/mask_top.13caa1f4.png";